exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".display-custom[data-v-306f7be6]{font-size:.95rem!important;height:1px!important}", ""]);

// exports
